import { StandardIconButton } from "components";
import { NoltWidget } from "./NoltWidget";
import { AccountSelect } from "./AccountSelect";
import { Box, HStack, Link } from "@chakra-ui/react";
import { Navigation } from "./Navigation/Navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { useAppStore } from "utils/react-hooks/useAppStore.hook";
import { observer } from "mobx-react";
import { NavButton } from "components/nav-button/NavButton";
import Logo from "components/Logo";

export const LeftSideBar = observer(() => {
  const {
    uiStore,
    userAccountsStore: { selectedAccountStore },
  } = useAppStore();

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      width={"100%"}
      bg="leadpro.50"
      pb={3}
      borderRight="1px solid"
      borderColor="leadpro.200"
    >
      <HStack
        width={"100%"}
        justify={"space-between"}
        align={"center"}
        mb={3}
        pl={3}
        pr={3}
        height={"70px"}
      >
        <Box ml={3}>
          <Logo />
        </Box>
        <StandardIconButton
          aria-label={"collapse-left-side-bar"}
          color={"leadpro.400"}
          icon={<FontAwesomeIcon icon={faSquareChevronLeft} fontSize={20} />}
          onClick={() => uiStore.toggleLeftSidebar()}
        />
      </HStack>
      <Box px={3} mb={3}>
        <AccountSelect />
      </Box>
      {!!selectedAccountStore && (
        <Navigation accountStore={selectedAccountStore} />
      )}
      <Box mt="auto" width="100%">
        <Link
          href={
            "https://service.hub.nurtur.tech/servicedesk/customer/portal/50/group/112/create/243"
          }
          target={"_blank"}
        >
          <NavButton>Support</NavButton>
        </Link>
        <NoltWidget />
      </Box>
    </Box>
  );
});
